import React from "react";
import { Link, useLocation } from "react-router-dom";
import { add, inventory, msg, overview, stat } from "../../assets";
import { useDispatch } from "react-redux";
import { signout } from "../../redux/actions";

const mainNavItems = [
  {
    navTitle: "Overview",
    navIcon: overview,
    navRoute: "/user/index",
  },

  // {
  //   navTitle: "Buy",
  //   navIcon: "https://cdn-icons-png.flaticon.com/128/3737/3737372.png",
  //   navRoute: "/user/checkout-list",
  //   badge: 0,
  // },
  {
    navTitle: "My Inventory",
    navIcon: inventory,
    navRoute: "/user/my-inventory",
  },
  {
    navTitle: "Create Listing",
    navIcon: add,
    navRoute: "/user/create-listing",
    badge: 0,
  },
  {
    navTitle: "Messages",
    navIcon: msg,
    navRoute: "/user/messenger",
    badge: 0,
  },
  // {
  //   navTitle: "Notepad",
  //   navIcon: "https://cdn-icons-png.flaticon.com/128/9332/9332861.png",
  //   navRoute: "/user/notepad",
  // },
  // {
  //   navTitle: "Saved searches",
  //   navIcon: "https://cdn-icons-png.flaticon.com/128/4554/4554563.png",
  //   navRoute: "/user/saved-searches",
  //   badge: 0,
  // },

  // {
  //   navTitle: "Statistics",
  //   navIcon: stat,
  //   navRoute: "/user/statistics",
  // },
];

const secondaryNavItems = [
  {
    navTitle: "Profile",
    navIcon: "https://cdn-icons-png.flaticon.com/128/9187/9187475.png",
    navRoute: "/user/data",
  },
  {
    navTitle: "Notifications",
    navIcon: "https://cdn-icons-png.flaticon.com/128/10156/10156084.png",
    navRoute: "/user/settings",
    badge: "",
  },
  // {
  //   navTitle: "Log out",
  //   navIcon: "https://cdn-icons-png.flaticon.com/128/15784/15784577.png",
  //   navRoute: "/user/logout",
  // },
];

const UserProfileNavbar = () => {
  const dispatch = useDispatch();
  return (
    <nav className="bg-white  w-full p-4 space-y-1">
      <ul className="text-gray-800 text-[15px]">
        {mainNavItems.map((item, index) => (
          <NavItem
            key={index}
            navTitle={item.navTitle}
            navIcon={item.navIcon}
            navRoute={item.navRoute}
            badge={item.badge}
          />
        ))}

        <li className="border-y mt-2 py-2">
          <ul>
            {secondaryNavItems.map((item, index) => (
              <NavItem
                key={index}
                navTitle={item.navTitle}
                navIcon={item.navIcon}
                navRoute={item.navRoute}
                badge={item.badge}
              />
            ))}
          </ul>
        </li>

        <li>
          <div
            className="flex items-center py-2.5 space-x-2  hover:text-primary cursor-pointer"
            onClick={() => dispatch(signout())}
          >
            <img
              src="https://cdn-icons-png.flaticon.com/128/15784/15784577.png"
              height={24}
              width={24}
              alt=""
            />
            <p className="text-[14px]">Logout</p>
            {/* {badge !== undefined && badge !== 0 && badge !== "" && (
              <span className="pill bg-red-500 text-white text-[12px] font-semibold rounded-full text-center h-[16px] w-[16px] ml-auto">
                {badge}
              </span>
            )} */}
          </div>
        </li>
      </ul>
    </nav>
  );
};

export default UserProfileNavbar;

const NavItem = ({ navTitle, navIcon, navRoute, badge }) => {
  const location = useLocation();
  // console.log(location?.pathname);

  return (
    <li>
      <Link
        to={navRoute}
        className="flex items-center py-2.5 space-x-2  hover:text-[#D2D1CA]"
      >
        <img src={navIcon} height={24} width={24} alt="" />
        <p
          className={`text-[14px] ${
            location?.pathname === navRoute && "text-black-800 font-semibold"
          }`}
        >
          {navTitle}
        </p>
        {badge !== undefined && badge !== 0 && badge !== "" && (
          <span className="pill bg-red-500 text-white text-[12px] font-semibold rounded-full text-center h-[16px] w-[16px] ml-auto">
            {badge}
          </span>
        )}
      </Link>
    </li>
  );
};
